import { createFileRoute } from '@tanstack/react-router';

import CalibrationStage from '@/ui/pages/Installer/stages/calibration/CalibrationStage';

// HS-1638: stage 3 — face-velocity calibration and its immutable record.
export const Route = createFileRoute('/_dashboard/installer/installations/$id/calibration')({
  component: CalibrationStage,
});
